import i18n from 'services/base/i18n';

export default {
  name: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Plan Information',
    'Plan Information'
  ),

  following: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Plan Information',
    'This plan covers the following'
  ),

  featureFirewall: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Plan Information|Features',
    'Functionality of the physical Pangolin Smart Firewall device'
  ),

  featureUpdates: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Plan Information|Features',
    'Access to device software and security policy updates'
  ),

  featureApp: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Plan Information|Features',
    'Management via the companion Pangolin Smart Firewall app'
  ),
};
